import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import ScheduleGradeAircraftLineDays from './ScheduleGradeAircraftLineDays';

class ScheduleGradeAircraftLineAlternate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      schedule_id: this.props.schedule_id,
      schedule_grade_id: this.props.schedule_grade_id,
      edit_mode: this.props.edit_mode,
      toggled: 0,
      sgas: {},
    };

    //bind específico
    this.toggleAllSelect = this.toggleAllSelect.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.sgas.staff !== 'undefined') || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        sgas: newProps.sgas,
        loaded: 1,
      });
    }
    this.setState({edit_mode: newProps.edit_mode});

  }


  toggleAllSelect() {
    this.setState({
      toggled: 1,
    });
  }
    

  render() {
    var self = this;
    var alert_level = self.state.sgas.alert_level;
    if(self.state.sgas.alert_level === null) alert_level = 'default';
    return (
  <tr>

    <td className="text-center table-schedule-sticky table-schedule-main-del-alternate">
    {self.state.edit_mode && <button className="btn btn-danger btn-xs" onClick={() => self.props.deleteLineAlternate(self.state.sgas.sgas_id)}><i className="fa fa-trash"></i></button>}
    </td>
    <td className="text-center table-schedule-sticky table-schedule-main-name-alternate">
      <RequestApi ref={'request_api'} handleLoaded={this.props.handleLoaded} />
      {self.state.sgas.staff}
      <br />
      {!self.state.edit_mode && <button className={'btn btn-' + alert_level + ' btn-xs'} onClick={() => self.props.generatePersonalAlerts(self.state.sgas.sgas_id)}><i className="fa fa-warning"></i></button>}

    </td>
    <td className="text-center table-schedule-sticky table-schedule-main-inscription-alternate">{self.state.sgas.inscription}</td>
    <td className="text-center table-schedule-sticky table-schedule-main-designation-alternate">{self.state.sgas.role_alternate}</td>
    {Object.keys(self.props.schedule_days).map(function(k) {
      var day = self.props.schedule_days[k];
      if (typeof self.state.sgas.days !== 'undefined') {
        if (typeof self.state.sgas.days[day.day] !== 'undefined') {
          return(
            <ScheduleGradeAircraftLineDays schedule_id={self.props.schedule_id} schedule_grade_id={self.props.schedule_grade_id} updateData={self.props.updateData} toggleAllSelect={self.toggleAllSelect} updated={self.props.updated} handleAlert={self.props.handleAlert} initials_colors={self.props.initials_colors} types_list={self.props.types_list} sgas_id={self.state.sgas.sgas_id} toggled={self.state.toggled} date={day.day} day={self.state.sgas.days[day.day]} edit_mode={self.state.edit_mode} toggleEditMode={self.props.toggleEditMode} changeDateType={self.props.changeDateType} zoom_level={self.props.zoom_level} cloneDay={self.props.cloneDay} />
          );
        } else {
          return(
            <td style={{background: 'blue'}}>&nbsp;</td>
          );
        }
        return('');  
      }
    })}

  </tr>
    );
  }
}

export default ScheduleGradeAircraftLineAlternate;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeAircraftLineAlternate.js